import React, { useState, useEffect } from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import { IoIosSearch } from 'react-icons/io';

import { getConditions } from '../../../../api/services/conditionsApi';
import ConditionCard from '../../../../components/main/cards/ConditionCard/ConditionCard';

import './ConditionsTreated.css';

export default function ConditionsTreated() {
  const [searchField, setSearchField] = useState('');
  const [conditions, setConditions] = useState([]);
  const [filteredConditions, setFilteredConditions] = useState(conditions);

  //Set Pagination variables
  const [currentPage, setCurrentPage] = useState(1);
  const conditionsPerPage = 6;

  // Handle showing conditons per page
  const startIndex = (currentPage - 1) * conditionsPerPage;
  const currentPageConditions = filteredConditions.slice(
    startIndex,
    startIndex + conditionsPerPage,
  );

  //Handle Change Page
  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  //Set Pagination
  const totalPages = Math.ceil(filteredConditions.length / conditionsPerPage);
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const pagination = pages.map((page, i) => {
    return (
      <div key={i} className='conditions-btn-container'>
        <button
          onClick={() => handleChangePage(page)}
          className={`conditions-button ${
            currentPage === page ? 'active' : ''
          }`}
          disabled={currentPage === page}
        >
          {page}
        </button>
        {totalPages > 1 && i === totalPages - 1 ? (
          <button
            onClick={() => handleChangePage(page)}
            className={`conditions-button ${
              currentPage === page ? 'active' : ''
            }`}
            disabled={currentPage === page}
          >
            <span className='conditions-btn-last'>
              Last
              <IoIosArrowForward />
            </span>
          </button>
        ) : null}
      </div>
    );
  });

  //Get All Conditions
  useEffect(function () {
    const getAllConditions = async () => {
      const allConditions = await getConditions();
      setConditions(allConditions);
    };
    getAllConditions();
  }, []);

  //Search Condition by search field
  useEffect(
    function () {
      const newFilteredConditions = conditions.filter((condition) => {
        return (
          condition.name.toLocaleLowerCase().includes(searchField) ||
          condition.tags.join(' ').toLocaleLowerCase().includes(searchField)
        );
      });
      setFilteredConditions(newFilteredConditions);
      setCurrentPage(1);
    },
    [conditions, searchField],
  );

  const onSearchChange = (e) => {
    setSearchField(e.target.value.toLocaleLowerCase());
  };

  return (
    <div className='conditions_page-container'>
      <div className='contitions-content-container'>
        <div>
          <h1 className='condition__title'>CONDITIONS TREATED</h1>
        </div>
        <div className='condition__search'>
          <input
            className='search__input'
            type='text'
            placeholder='Search for conditions treated'
            onChange={onSearchChange}
            value={searchField}
          />
          <span className='search-icon'>
            <IoIosSearch />
          </span>
        </div>
        <div className='condition__cardGroup'>
          {currentPageConditions.map((p, i) => (
            <div key={startIndex + i} className='condition-card-container'>
              <ConditionCard
                title={p.name}
                leftDesc={p.description}
                image={p.imageUrl}
              />
            </div>
          ))}
        </div>
        <div className='pagination'>{pagination}</div>
      </div>
    </div>
  );
}
